
import {jwtDecode} from 'jwt-decode';

export function tokenIsExpired(token) {
  try {
    const decodedToken = jwtDecode(token);
    const expirationTime = decodedToken.exp * 1000;

    if (!decodedToken || expirationTime < Date.now()) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
}
